const registerModule = require('./registerModule');
const timingTracker = require('./TimingTracker');
const adobe = require('./Adobe/adobe');

module.exports = (flex = window.flex, FlexApiRequest = window.FlexApiRequest) => {
    return {
        registerModule: registerModule(flex, FlexApiRequest),
        TimingTracker: timingTracker(flex),
        adobe: adobe(flex)
    };
};